import { fetcherReactQuery } from '../../services/api/fetcher'
import { useQuery } from 'react-query'

const fetch = async (api) => {
    const response = await fetcherReactQuery(api)
    return response.data
}
const usePendingApplication = (userId) => {
    return useQuery([`/api/solicitudadmin/pending-applicant/${userId}`], fetch);
}

export default usePendingApplication






